export const balanceDetailData = state => state.balanceDetailData
export const mapAddressInfo = state => state.mapAddressInfo // 地图地址信息
export const isDeliveryNewVerison = state => state.isDeliveryNewVerison // 地图地址信息
export const getCancelReasonList = state => state.cancelReasonList
